<h1 class="timeline-title">Latest Warnings</h1>
<div class="container">
    <div class="history-tl-container">
        <div class="timeline-content">
            <ul class="tl">
                <li *ngFor="let warning of displayedWarnings" class="tl-item">
                    <div class="timestamp">
                        {{ warning.detection_datetime | date:'medium' }}
                    </div>
                    <div class="item-title">{{ warning.title }}</div>
                    <div class="item-detail">{{ warning.location }}</div>
                </li>
            </ul>
        </div>
    </div>
    <div class="load-more" *ngIf="startIndex < warnings.length">
        <button (click)="showMore()">Show More</button>
    </div>
</div>
